const MAXIMUM_MONTH_LABELS = 12;

export function monthLabelStep(monthCount: number): number {
  return Math.max(1, Math.ceil(monthCount / MAXIMUM_MONTH_LABELS));
}

export function shortMonthLabel(month: string, showYear: boolean): string {
  return new Date(`${month}-15T00:00:00Z`).toLocaleDateString("en-US", {
    month: "short",
    year: showYear ? "2-digit" : undefined,
    timeZone: "UTC",
  });
}

export function spansMoreThanOneYear(months: string[]): boolean {
  return months.length > 0 && months[0].slice(0, 4) !== months[months.length - 1].slice(0, 4);
}
